import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardFeature } from "@/lib/policy/route-guard";
import { MaintenanceGate } from "./-components/maintenance-gate";
import { MaintenanceTabs } from "./-components/maintenance-tabs";

/** Maintenance: the building's work orders, its parts shop and the parts to buy, with David
    beside them in the right-hand pane. */
export const Route = createFileRoute("/_authenticated/_maintenance/maintenance")({
  beforeLoad: ({ context }) => guardFeature(context.me, "maintenance"),
  head: () => ({
    meta: [
      { title: "Maintenance | People AI" },
      {
        name: "description",
        content: "Work orders, the parts shop and the parts to buy.",
      },
    ],
  }),
  component: MaintenanceLayout,
});

function MaintenanceLayout() {
  return (
    <div className="w-full min-w-0 space-y-5">
      <PageHeader title="Maintenance" meta="What is broken, who has it, and what it takes to fix" />
      <MaintenanceGate>
        <MaintenanceTabs />
        <Outlet />
      </MaintenanceGate>
    </div>
  );
}
